import { WhatsappMessageType } from "@jugl-web/rest-api";

export const SUPPORTED_WHATSAPP_PAYLOAD_TYPES = [
  WhatsappMessageType.audio,
  WhatsappMessageType.document,
  WhatsappMessageType.video,
  WhatsappMessageType.image,
  WhatsappMessageType.text,
  WhatsappMessageType.sticker,
];
